export interface TaxResult {
    cgst: number;
    sgst: number;
    igst: number;
    totalTax: number;
}

export interface TaxParams {
    amount: number;
    taxRate: number;
    customerState?: string;
    companyState?: string;
}

// IGST is always manual entry per business rules.
// Tax is always split as CGST + SGST; IGST stays 0 from auto-calculation.
export const calculateTax = ({
    amount,
    taxRate,
}: TaxParams): TaxResult => {
    const totalTax = (amount * taxRate) / 100;
    const halfTax = totalTax / 2;
    return { cgst: halfTax, sgst: halfTax, igst: 0, totalTax };
};